module.exports = __webpack_public_path__ + "img/art-lieferung.a169a0f2.png";